export default [
    {
        path: '/forgot-password',
        name: 'forgot-password',
        component: () => import('@/views/forgotPassword/index2.vue'),
        meta: {
            layout: 'full',
        },
    },
]